
export const toggleFullscreen = (containerRef, videoRef) => {
  const container = containerRef.current;
  const video = videoRef.current;

  const isIPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;

  if (!document.fullscreenElement && !document.webkitFullscreenElement) {
    // Request fullscreen
    if (isIPhone && video) {
      // Use video element for fullscreen on iPhone
      if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen(); // iPhone-specific method
      }
    } else if (container.requestFullscreen) {
      container.requestFullscreen();
    } else if (container.webkitRequestFullscreen) {
      container.webkitRequestFullscreen(); // Safari
    } else if (container.mozRequestFullScreen) {
      container.mozRequestFullScreen(); // Firefox
    } else if (container.msRequestFullscreen) {
      container.msRequestFullscreen(); // IE/Edge
    }
  } else {
    // Exit fullscreen
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen(); // Safari
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen(); // Firefox
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen(); // IE/Edge
    }
  }
};

export const formatTime = (time) => {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

export const handleStepForward = (videoRef) => {
        const video = videoRef.current;
        video.currentTime = Math.min(video.duration, video.currentTime + 5);
    };

export const handleStepBackward = (videoRef) => {
        const video = videoRef.current;
        video.currentTime = Math.max(0, video.currentTime - 5);
    };